export var RouteChangeIndicatorDirective = [
    '$rootScope',
    function ($rootScope) {
        return {
            link: function ($scope) {
                $scope.isRouteLoading = false;
                $rootScope.$on('$routeChangeStart', function () {
                    $scope.isRouteLoading = true;
                });
                $rootScope.$on('$routeChangeSuccess', function () {
                    $scope.isRouteLoading = false;
                });
            },
            restrict: 'E',
            template: "<div ng-show=\"isRouteLoading\" class=\"content-preloader\"></div>",
        };
    },
];
